module.exports = __webpack_public_path__ + "static/img/master-3.8b046359.png";